import React, { PureComponent } from 'react';
import {
  Form, Input, Button, Rate, notification,
} from 'antd';
import StarIcon from 'material-design-icons/action/svg/production/ic_star_rate_18px.svg';
import PropTypes from 'prop-types';
import cx from 'classnames';

import c from './ReviewForm.less';

const { TextArea } = Input;
const FormItem = Form.Item;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class ReviewForm extends PureComponent {
  static propTypes = {
    form: PropTypes.object.isRequired,
    labels: PropTypes.object,
    displayTitleField: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    submitTitle: PropTypes.string,
  };

  static defaultProps = {
    labels: {},
    displayTitleField: false,
    loading: false,
    submitTitle: 'Add Feedback',
  };

  state = {
    isActive: false,
    serverErrors: {},
  };

  componentDidMount() {
    this.props.form.validateFields();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isActive && !prevState.isActive) {
      this.props.form.validateFields();
    }
  }

  handleRateChange = (value) => {
    this.props.form.setFieldsValue({
      rate: value,
    });
  };

  handleDataChange = () => {
    const dataValue = this.props.form.getFieldValue('message');

    this.setState({
      isActive: !!(dataValue && dataValue.length > 0),
    });
  };

  handleDataBlur = () => {
    const dataValue = this.props.form.getFieldValue('message');
    const isActive = !!(dataValue && dataValue.length > 0);

    this.setState({
      isActive,
    });

    if (!isActive) {
      this.props.form.resetFields('message');
    }
  };

  handleFormSubmit = (e) => {
    e.preventDefault();
    const { form } = this.props;
    this.setState({
      serverErrors: {},
    });

    form.validateFields((err, values) => {
      if (!err) {
        this.props.onSubmit(err, values)
          .then(() => {
            this.props.form.resetFields();
            this.setState({
              isActive: false,
            });
          })
          .catch((serverErrors) => {
            this.setState({
              serverErrors,
            });

            const fields = Object.keys(serverErrors)
              .filter((key) => serverErrors[key])
              .reduce((acc, key) => {
                acc[key] = {
                  errors: serverErrors[key].map((fieldError) => new Error(fieldError)),
                  value: form.getFieldValue(key),
                  touched: form.isFieldTouched(key),
                  dirty: true,
                };

                return acc;
              }, {});

            form.setFields(fields);
          });
      } else {
        notification.error({
          message: 'Oops! Errors in submitted feedback.',
          description: (
            <ul>
              {
                Object.keys(err).reduce((acc, errField) => {
                  return acc.concat(err[errField].errors.map((error) => <li key={error.message}>{error.message}</li>));
                }, [])
              }
            </ul>
          ),
        });
      }
    });
  };

  render() {
    const {
      form: {
        getFieldDecorator, getFieldsError, isFieldTouched, getFieldError,
      }, labels, displayTitleField, loading,
    } = this.props;
    const { isActive, serverErrors } = this.state;

    return (
      <form className={c.formBlock} onSubmit={this.handleFormSubmit}>
        <FormItem>
          {getFieldDecorator('message', {
            rules: [{
              required: isActive,
              message: 'Please fill review',
            }, {
              max: 4000,
            }],
          })(
            <TextArea
              className={cx(c.dataInput, { [c.error]: isFieldTouched('message') && getFieldError('message') })}
              placeholder="Write review here"
              onChange={this.handleDataChange}
              onBlur={this.handleDataBlur}
              type="textarea"
              autoSize={{ minRows: 4 }}
            />,
          )}
        </FormItem>
        {
          isActive && (
            <div className={c.header}>
              {
                displayTitleField ? (
                  <div className={c.title}>
                    <label className={c.label} htmlFor="title">Feedback title </label>
                    {getFieldDecorator('title', {
                      rules: [{
                        required: isActive,
                        message: 'Please fill in feedback title',
                      }, {
                        max: 120,
                        min: 1,
                      }],
                    })(
                      <Input
                        className={cx(c.input, { [c.error]: isFieldTouched('title') && getFieldError('title') })}
                        name="title"
                      />,
                    )}
                  </div>
                ) : null
              }
              <div className={c.name}>
                <label className={c.label} htmlFor="username">Your Name </label>
                <FormItem
                  help={getFieldError('username') && serverErrors.username ? serverErrors.username : ''}
                >
                  {getFieldDecorator('username', {
                    rules: [{
                      required: isActive,
                    }, {
                      max: 40,
                      min: 1,
                    }],
                  })(
                    <Input
                      className={cx(c.input, { [c.error]: isFieldTouched('username') && getFieldError('username') })}
                      name="username"
                    />,
                  )}
                </FormItem>
              </div>
              <div className={c.rating}>
                <label
                  className={c.label}
                  htmlFor="rate"
                >
                  {labels.rate || 'Rate this release'}
                </label>
                {getFieldDecorator('rate', {
                  rules: [{
                    required: isActive,
                    message: 'Please rate',
                  }, {
                    min: 1,
                    type: 'integer',
                  }],
                })(
                  <div className={c.rateControl}>
                    <Rate
                      character={<StarIcon />}
                      onChange={this.handleRateChange}
                      value={this.props.form.getFieldValue('rate')}
                    />
                  </div>,
                )}
              </div>
              <div className={c.reviewAction}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  className={c.submit}
                  disabled={hasErrors(getFieldsError())}
                >
                  {this.props.submitTitle}
                </Button>
              </div>
            </div>
          )
        }
      </form>
    );
  }
}

export default Form.create()(ReviewForm);
